import { useEnum } from "@/api/services/global/enum";
import { CheckboxGroup } from "@/components/elements/CheckboxGroup";
import { InnerBox } from "@/components/elements/InnerBox";
import { useGetUserSettingInfo } from "@/features/user-setting";
import { black, divider } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";

type TEmailDeliveryInfoProps = {};

export const EmailDeliveryInfo: FC<TEmailDeliveryInfoProps> = () => {
  const { data: emailDeliveryOptions } = useEnum("EEmailDelivery");
  const { data: userSettingResult } = useGetUserSettingInfo();

  return (
    <InnerBox padding={3} showDivider={false} borderColor={divider.high}>
      <Stack alignItems="flex-start">
        <Typography variant="head20Bold" color={black[30]}>
          メール配信設定
        </Typography>

        <Stack mt={2}>
          <CheckboxGroup disabled value={userSettingResult?.data.emailDeliveryOptions ?? []} options={emailDeliveryOptions} />
        </Stack>
      </Stack>
    </InnerBox>
  );
};
